import {
  WSCard,
  WSControlGroup,
  WSElement,
  WSForm,
  WSIconList,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { WSCardProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCard";
import {
  OccupationalAccidentAccidentMedicalMinimum,
  OccupationalAccidentAdAndDMinimum,
  WorkInjuryAcceptedCoverageType,
  WorkInjuryEmployerLiabilityBundle
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { getLimitOptions } from "./getLimitOptions";

export const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUM_COMMON: OccupationalAccidentAccidentMedicalMinimum = 250000;
const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS: OccupationalAccidentAccidentMedicalMinimum[] =
  [100000, 250000, 500000, 1000000];

export const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUM_COMMON: OccupationalAccidentAdAndDMinimum = 50000;
const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS: OccupationalAccidentAdAndDMinimum[] =
  [50000, 100000, 250000, 500000];

const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS_OPTIONS = getLimitOptions(
  WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS,
  WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUM_COMMON
);

const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS_OPTIONS = getLimitOptions(
  WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS,
  WORKER_OCCUPATIONAL_ACCIDENT_MINIMUM_COMMON
);

export const FormPartialWorkInjury: React.FC<WSCardProps> = props => {
  return (
    <WSCard {...props}>
      <WSSectionToolbar title="Your requirements for uploaded insurance" />
      <WSList gap="L" mt="L">
        <WSForm.Field
          name="coverageType"
          component={WSControlGroup}
          label="What coverage types will you accept?"
          componentProps={{
            type: "radio",
            size: "S",
            required: true,
            helperText: "Select one",
            chip: true,
            options: [
              {
                value: WorkInjuryAcceptedCoverageType.WorkersCompensation,
                label: (
                  <>
                    <b>Workers' Compensation only</b> - Traditional
                    state-regulated coverage
                  </>
                )
              },
              {
                value: WorkInjuryAcceptedCoverageType.OccupationalAccident,
                label: (
                  <>
                    <b>Occupational Accident only</b> - Alternative injury
                    coverage for 1099s
                  </>
                )
              },
              {
                value: WorkInjuryAcceptedCoverageType.Either,
                label: (
                  <>
                    <b>Either one</b> - Accept Workers' Comp OR Occupational
                    Accident
                  </>
                )
              }
            ]
          }}
        />

        <WSForm.Value name="coverageType">
          {(coverageType: WorkInjuryAcceptedCoverageType) => (
            <>
              <WSInfoBox
                theme="info"
                title="Worker’s Compensation coverage"
                icon="settings"
                style={{
                  display: [
                    WorkInjuryAcceptedCoverageType.WorkersCompensation,
                    WorkInjuryAcceptedCoverageType.Either
                  ].includes(coverageType)
                    ? "block"
                    : "none"
                }}
              >
                {/* TODO: update lib*/}
                <WSElement style={{ width: "100%" }}>
                  <WSForm.Field
                    name="workersCompLimitMinimum"
                    label="Employer's liability limits (minimum)"
                    component={WSSelect}
                    componentProps={{
                      required: true,
                      helperText:
                        "Per accident / Total for disease / Per employee disease limits for each coverage tier (select one)",
                      options: [
                        {
                          value:
                            WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred,
                          label:
                            "$100,000 / $500, 000 / $100, 000 Standard coverage"
                        },
                        {
                          value:
                            WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred,
                          label: "$500,000 / $500,000 / $500,000"
                        },
                        {
                          value:
                            WorkInjuryEmployerLiabilityBundle.OneMillionBundle,
                          label: "$1,000,000 / $1,000,000 / $1,000,000"
                        }
                      ]
                    }}
                  />
                </WSElement>
              </WSInfoBox>

              <WSInfoBox
                theme="info"
                title="Occupational Accident coverage"
                icon="settings"
                style={{
                  display: [
                    WorkInjuryAcceptedCoverageType.OccupationalAccident,
                    WorkInjuryAcceptedCoverageType.Either
                  ].includes(coverageType)
                    ? "block"
                    : "none"
                }}
              >
                {/* TODO: update lib*/}
                <WSElement style={{ width: "100%" }}>
                  <WSForm.Field
                    name="occAccidentMedicalMinimum"
                    label="Medical coverage (minimum per accident)"
                    component={WSSelect}
                    componentProps={{
                      required: true,
                      helperText:
                        "Maximum medical benefits for each work injury (select one)",
                      options: WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS_OPTIONS
                    }}
                  />

                  <WSForm.Field
                    mt="M"
                    name="occAccidentDeathMinimum"
                    label="Death & dismemberment benefit (minimum)"
                    component={WSSelect}
                    componentProps={{
                      required: true,
                      helperText:
                        "Lump sum for death or permanent injury from work accident (select one)",
                      options:
                        WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS_OPTIONS
                    }}
                  />
                </WSElement>
              </WSInfoBox>
            </>
          )}
        </WSForm.Value>

        <WSInfoBox
          theme="neutral"
          title="We automatically verify:"
          icon="shield-check-fill"
        >
          <WSIconList
            items={[
              "Valid COI format",
              "Contractor name matches",
              "Your company listed as certificate holder",
              "Coverage currently active",
              "Correct coverage type (WC or OccAcc)",
              "All limits meet your minimums"
            ]}
            iconProps={{
              name: "check-circle",
              color: "green500",
              size: "S"
            }}
          />
        </WSInfoBox>
      </WSList>
    </WSCard>
  );
};
